import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

export interface IUserReference {
    userId: string;
    date: Date;
}

export interface IUser {
    id: string;
    name: string;
    emailAddress: string;
    roles: string[];
}

@Injectable({
    providedIn: 'root'
})
export class UserService {
    constructor(private http: HttpClient) { }

    private _user?: IUser;
    $user = new BehaviorSubject<IUser | undefined>(this._user);

    get user() {
        return this._user;
    }
    set user(val: IUser | undefined) {
        this._user = val;
        this.$user.next(this._user);
    }

    getSelf = () => this.http.get<IUser>(`${environment.apiPath}/user/self`);
    list = () => this.http.get<IUser[]>(`${environment.apiPath}/users`);
}
